import { inject, observer } from 'mobx-react';
import React from 'react'

@inject('workAreaStore') @observer
class PickerColor extends React.Component {


  render(){
    const { cursorColor, cursorX, cursorY } = this.props.workAreaStore
    return (
      <div 
        className='cursor-picker'
        style={{
          position: 'absolute',
          border: `1px solid #fff`,
          top: cursorY,
          left: cursorX,
          height: '20px',
          width: '20px',
          background: cursorColor,
          borderRadius: '50%'
        }}
      >

      </div>
    )
  }

}

export default PickerColor